import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ScannerComponent } from '../../../shared/components/scanner/scanner.component';
import { PoButtonModule, PoContainerModule, PoPageModule, PoModalModule, PoModalComponent, PoModalAction, PoNotificationService, PoFieldModule, PoSelectOption } from '@po-ui/ng-components';
import { OrderModel } from '../../../models/order.model';
import { BarcodeReaderComponent } from '../../../shared/components/barcode-reader/barcode-reader.component';
import { Router } from '@angular/router';
import { CountService } from '../../../shared/service/count.service';
import { TokenService } from '../../../shared/service/token.service';
import { UserTerminalService } from '../../../shared/service/user-terminal.service';
import { OrderHeaderListComponent } from './order-header-list/order-header-list.component';
import { CommonModule } from '@angular/common';
import { FilterDropdownComponent } from '../../../shared/components/filter-dropdown/filter-dropdown.component';
import { FormsModule } from '@angular/forms';
import { ToasterService } from '../../../shared/service/toaster.service';

@Component({
  selector: 'app-order-header',
  imports: [FormsModule,
    CommonModule,
    PoButtonModule,
    PoContainerModule,
    PoPageModule,
    PoModalModule,
    PoFieldModule,
  ScannerComponent,
    OrderHeaderListComponent,
    FilterDropdownComponent],
  templateUrl: './order-header.component.html',
  styleUrl: './order-header.component.css'
})
export class OrderHeaderComponent implements AfterViewInit {
  onScanOrderCode(event: string) {
    if (isNaN(Number(event)))
      return;

    const eventNumber = Number(event);
    
    if (event.length > 4) {
      const branchCode = Number(String(event).substring(0, 4));
      const loggedBranchCode = this.tokenService.getBranch();

      if (Number(loggedBranchCode) != branchCode) {
        this.toastService.triggerAlert(`Empresa '${branchCode}' inválida para a operação. (Empresa atual: '${loggedBranchCode}')`, 'error');
        return;
      }

      const orderCode = Number(String(event).substring(4));
      this.SelectOrderIfFound(orderCode);
    } else {
      this.SelectOrderIfFound(eventNumber);
    }
  }
  @ViewChild('modalBarCodeReader', { static: false }) modalBarCodeReader!: PoModalComponent;
  @Input() terminalSelected!: string;
  @Output() onTerminalModalOpen = new EventEmitter();
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() orderSelected = new EventEmitter<OrderModel>();

  orders: OrderModel[] = [];
  filteredOrders: OrderModel[] = [];
  fadeInAnimation = false;
  nullFilter: boolean = false;
  seeFilter: boolean = false;
  itemFilter: string = '1';
  funnelIcon = 'an an-funnel-simple';
  funnelIconFill = 'an an-arrow-down';
  orderCodeFilter: string = '';
  sortAsc = true;
  readonly statusItens: Array<PoSelectOption> = [
    { label: 'A separar', value: '1' },
    { label: 'Separando', value: '2' }
  ];

  // secondaryActionBarCodeReader removido, não é mais utilizado

  constructor(
    private tokenService: TokenService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private userTerminalService: UserTerminalService,
    private toastService: ToasterService,
    private countService: CountService
  ) { }

  ngAfterViewInit(): void {
    if (!this.terminalSelected) {
      this.onTerminalModalOpen.emit();
      return;
    }

    this.getOrders();
    this.cdRef.detectChanges();
  }

  public getOrders() {
    this.loading(true);
    const loggedBranchCode = Number(this.tokenService.getBranch());
    const orderCodeFilter = Number(this.orderCodeFilter) !== 0 ? Number(this.orderCodeFilter) : null;
    this.countService.getOrdersHeader(loggedBranchCode, Number(this.terminalSelected), orderCodeFilter).subscribe({
      next: (response) => {
        this.loading(false);
        this.orders = response.items;
        this.onFilter();
        this.executeFadeInAnimation();
      }, error: () => {
        this.loading(false);
      }
    });
  }

  onOrderSelected(order: OrderModel) {
    this.orderSelected.emit(order);
  }

  onFilter() {
    this.nullFilter = false;
    let filteredItems: any = this.filterOrderByAllocationStatus();
    filteredItems.length > 0
      ? this.filteredOrders = filteredItems
      : this.nullFilter = true;
    this.sortByOrderDate();
    this.executeFadeInAnimation();
  }

  cleanFilter() {
    this.orderCodeFilter = '';
    this.itemFilter = '1';
    this.filteredOrders = this.filterOrderByAllocationStatus();
    this.nullFilter = false;
    this.sortAsc = true;
    this.executeFadeInAnimation();
  }

  filterOrderByAllocationStatus() {
    return this.orders.filter((item) => item.allocationStatus === parseInt(this.itemFilter));
  }

  changeSort() {
    this.sortAsc = !this.sortAsc;
    this.sortByOrderDate();
  }

  sortByOrderDate() {
    this.filteredOrders.sort((a: any, b: any) => this.sortAsc ? (new Date(a.orderDate).getTime() - new Date(b.orderDate).getTime()) : (new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime()));
  }

  loading(value: boolean) {
    this.isLoading.emit(value);
  }

  executeFadeInAnimation() {
    this.fadeInAnimation = false;
    setTimeout(() => {
      this.fadeInAnimation = true;
    }, 10);
  }

  // startBarCodeReader removido, não é mais utilizado

  onReadBarcodeReader(event: any) {
    if (isNaN(Number(event)))
      return;

    var branchCode = Number(String(event).substring(0, 4));
    var loggedBranchCode = this.tokenService.getBranch();

    if (Number(loggedBranchCode) != branchCode) {
      this.toastService.triggerAlert(`Empresa '${branchCode}' inválida para a operação. (Empresa atual: '${loggedBranchCode}')`, 'error');
      return;
    }

    var orderCode = Number(String(event).substring(4));

    this.SelectOrderIfFound(orderCode);
  }

  SelectOrderIfFound(orderCode: number) {
    var order = this.orders.find((item) => item.orderCode == orderCode);

    if (order) {
      this.onOrderSelected(order);
      return;
    }

    this.toastService.triggerAlert(`Pedido ${orderCode} não encontrado`, 'error');
  }

  turnOffBarcodeReader() {
    this.modalBarCodeReader.close();
  }

  recoverStatusSelected(event: any) {
    this.itemFilter = event;
  }

  onClick() {
    this.seeFilter = !this.seeFilter;
  }

  setOrderCodeFilter(event: any) {
    this.orderCodeFilter = event;
  }

}
